document.addEventListener('DOMContentLoaded', function () {
    const mobileQuery = window.matchMedia('(max-width: 991px)');

    function enableMobileClick() {
        if (!mobileQuery.matches) return;

        document.querySelectorAll('.image-card-wrap').forEach(function (wrap) {
            wrap.addEventListener('click', function (e) {
                e.stopPropagation();

                const card = wrap.closest('.image-card');

                // close others
                document.querySelectorAll('.image-card.is-open').forEach(c => {
                    if (c !== card) c.classList.remove('is-open');
                });

                card.classList.toggle('is-open');
            });
        });

        document.addEventListener('click', function () {
            document.querySelectorAll('.image-card.is-open').forEach(card => {
                card.classList.remove('is-open');
            });
        });
    }

    enableMobileClick();
});